import { useGet } from "@onefront/react-sdk";

interface UtilitiesGetParamsFetch {
    params?: any;
    headers?: any;
}

interface IUseGetAssets {
    (resourceName: string, lazy?: boolean): {
        data?: Array<any>;
        loading?: boolean;
        fetch: (fetchConfig?: UtilitiesGetParamsFetch) => Promise<any>;
        error: boolean;
        lazy?: boolean;
    };
}

export const useGetAssets: IUseGetAssets = (resourceName, lazy = true) => {
    return useGet(`rnd:core:workspace-bff:api://v1/utilities/assets`, {
        lazy
    });
};
